module.exports = __webpack_public_path__ + "img/tsm-artists.44ba562d.svg";